module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-right-circle-fill-5c961391.svg";